import z from 'zod';

type EnumValue = string | number;
type EnumLike = Readonly<Record<string, EnumValue>>;

/**
 * Allow Zod enums to parse ints as the corresponding string enum values
 * @param zodEnum Zod enum to wrap with transform
 */
export function zodTransformEnum<T extends EnumLike>(
    zodEnum: z.ZodOptional<z.ZodNullable<z.ZodEnum<T>>>,
): z.ZodPipe<z.ZodTransform<unknown, unknown>, z.ZodOptional<z.ZodNullable<z.ZodEnum<T>>>>;
export function zodTransformEnum<T extends EnumLike>(zodEnum: z.ZodEnum<T>): z.ZodPipe<z.ZodTransform<unknown, unknown>, z.ZodEnum<T>>;
export function zodTransformEnum<T extends EnumLike>(zodEnum: z.ZodEnum<T> | z.ZodOptional<z.ZodNullable<z.ZodEnum<T>>>) {
    const rawEnum = zodEnum instanceof z.ZodEnum ? zodEnum : zodEnum.unwrap().unwrap();

    return z
        .transform((val) => {
            if (typeof val === 'number' && val in rawEnum.options) {
                return rawEnum.options[val];
            }

            return val;
        })
        .pipe(zodEnum);
}
